const IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'avif', 'bmp', 'ico']);
const TEXT_EXTENSIONS = new Set([
  'txt',
  'md',
  'markdown',
  'csv',
  'tsv',
  'json',
  'xml',
  'log',
  'yaml',
  'yml',
  'html',
  'css',
  'js',
  'jsx',
  'ts',
  'tsx',
  'py',
  'rs',
  'sql',
  'sh',
]);

export const getFileExtension = (fileName: string) => fileName.match(/\.([a-z0-9]+)$/i)?.[1].toLowerCase() ?? '';

export const getFilePreviewType = (fileName: string, mimeType: string) => {
  const extension = getFileExtension(fileName);
  if (mimeType.startsWith('image/') || IMAGE_EXTENSIONS.has(extension)) return 'image';
  if (mimeType === 'application/pdf' || extension === 'pdf') return 'pdf';
  if (
    mimeType.startsWith('text/') ||
    mimeType === 'application/json' ||
    mimeType === 'application/xml' ||
    TEXT_EXTENSIONS.has(extension)
  )
    return 'text';
  return 'other';
};
